<template>
  <transition name="slide">
    <div v-if="visible" class="fixed inset-0 z-50 flex select-none">

      <div
        class="absolute inset-0 backdrop-blur-sm transition-opacity duration-300"
        :class="isDark ? 'bg-black/60' : 'bg-black/40'"
        @click="$emit('close')"
      ></div>

      <transition name="slide">
        <div class="relative ml-auto w-full max-w-sm backdrop-blur-md shadow-2xl flex flex-col h-full border-l text-left font-light transition-colors duration-200"
          :class="isDark ? 'bg-zinc-900/95 border-zinc-900 text-zinc-400' : 'bg-white border-gray-200 text-gray-600'">

          <header class="flex items-center justify-between p-5 border-b transition-colors duration-200"
            :class="isDark ? 'border-zinc-900/60 bg-zinc-950' : 'border-gray-200 bg-gray-50'">
            <div class="space-y-0.5">
              <div class="flex items-center gap-2 transition-colors duration-200"
                :class="isDark ? 'text-[#D5CCBC]' : 'text-blue-600'">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <h2 class="text-sm font-medium tracking-wide transition-colors duration-200"
                  :class="isDark ? 'text-white' : 'text-gray-900'">Fiche de Session</h2>
              </div>
              <p class="text-[10px] font-light transition-colors duration-200"
                :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Spécifications techniques de l'acte programmé.</p>
            </div>
            <button @click="$emit('close')" class="transition-colors focus:outline-none"
              :class="isDark ? 'text-zinc-500 hover:text-white' : 'text-gray-400 hover:text-gray-900'">
              <i class="fas fa-times text-sm"></i>
            </button>
          </header>

          <div class="p-5 flex-1 overflow-y-auto space-y-5 text-xs no-scrollbar transition-colors duration-200"
            :class="isDark ? 'bg-zinc-950/20' : 'bg-gray-50/50'">


            <div class="border p-4 rounded-xl space-y-2.5 transition-colors duration-200"
              :class="isDark ? 'border-zinc-900 bg-zinc-900/30 hover:border-zinc-800' : 'border-gray-200 bg-gray-50 hover:border-gray-300'">
              <h3 class="text-[10px] uppercase tracking-widest font-medium font-mono transition-colors duration-200"
                :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Affilié / Client</h3>
              <div class="space-y-1">
                <p class="font-medium text-sm tracking-wide transition-colors duration-200"
                  :class="isDark ? 'text-zinc-300' : 'text-gray-900'">{{ event?.nom || event?.clientName }}</p>
                <p class="flex items-center gap-2 font-mono text-[11px] transition-colors duration-200"
                  :class="isDark ? 'text-zinc-500' : 'text-gray-600'">
                  <i class="fas fa-phone text-[10px]"></i> {{ event?.telephone || 'N/A' }}
                </p>
                <p class="flex items-center gap-2 font-mono text-[11px] transition-colors duration-200"
                  :class="isDark ? 'text-zinc-500' : 'text-gray-600'">
                  <i class="fas fa-envelope text-[10px]"></i> {{ event?.email || 'N/A' }}
                </p>
              </div>
            </div>

            <div class="border p-4 rounded-xl space-y-3 transition-colors duration-200"
              :class="isDark ? 'border-zinc-900 bg-zinc-900/30 hover:border-zinc-800' : 'border-gray-200 bg-gray-50 hover:border-gray-300'">
              <h3 class="text-[10px] uppercase tracking-widest font-medium font-mono transition-colors duration-200"
                :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Prestations Sélectionnées</h3>
              <div class="flex flex-wrap gap-1.5">
                <span
                  v-if="!event?.service || event?.service.length === 0"
                  class="px-2.5 py-1 text-[10px] font-medium tracking-wide border rounded-lg transition-colors duration-200"
                  :class="isDark ? 'bg-zinc-900 text-zinc-400 border-zinc-800' : 'bg-gray-100 text-gray-500 border-gray-200'">
                  {{ event?.serviceName || 'Service non spécifié' }}
                </span>
                <span
                  v-for="(s, i) in event?.service || []"
                  :key="i"
                  class="px-2.5 py-1 text-[10px] font-medium tracking-wide border rounded-lg transition-colors duration-200"
                  :class="isDark ? 'bg-zinc-900 text-zinc-300 border-zinc-800' : 'bg-gray-100 text-gray-700 border-gray-200'">
                  {{ s.nom }}
                </span>
              </div>
            </div>

            <div class="border p-4 rounded-xl space-y-3 transition-colors duration-200"
              :class="isDark ? 'border-zinc-900 bg-zinc-900/30 hover:border-zinc-800' : 'border-gray-200 bg-gray-50 hover:border-gray-300'">
              <h3 class="text-[10px] uppercase tracking-widest font-medium font-mono transition-colors duration-200"
                :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Planification & Arbitrage</h3>

              <div class="space-y-2 font-light transition-colors duration-200"
                :class="isDark ? 'text-zinc-400' : 'text-gray-600'">
                <div class="flex justify-between items-center border-b pb-1.5 transition-colors duration-200"
                  :class="isDark ? 'border-zinc-900/40' : 'border-gray-200'">
                  <span class="transition-colors duration-200" :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Date d'exécution</span>
                  <span class="font-medium transition-colors duration-200" :class="isDark ? 'text-zinc-200' : 'text-gray-900'">{{ formatDate(event?.start || event?.date_rdv) }}</span>
                </div>

                <div class="flex justify-between items-center border-b pb-1.5 transition-colors duration-200"
                  :class="isDark ? 'border-zinc-900/40' : 'border-gray-200'">
                  <span class="transition-colors duration-200" :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Créneau horaire</span>
                  <span class="font-mono font-medium transition-colors duration-200" :class="isDark ? 'text-white' : 'text-gray-900'">
                    {{ event?.startTime || formatHourMinute(event?.start) }} — {{ event?.endTime || formatHourMinute(event?.end) }}
                  </span>
                </div>

                <div class="flex justify-between items-center border-b pb-1.5 transition-colors duration-200"
                  :class="isDark ? 'border-zinc-900/40' : 'border-gray-200'">
                  <span class="transition-colors duration-200" :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Opérateur assigné</span>
                  <span class="font-medium transition-colors duration-200" :class="isDark ? 'text-zinc-200' : 'text-gray-900'">{{ event?.employe?.nom || 'Non assigné' }}</span>
                </div>

                <div class="flex justify-between items-center border-b pb-1.5 transition-colors duration-200"
                  :class="isDark ? 'border-zinc-900/40' : 'border-gray-200'">
                  <span class="transition-colors duration-200" :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Statut Réseau</span>
                  <span
                    class="px-2 py-0.5 text-[9px] font-semibold uppercase tracking-wider font-mono rounded border"
                    :class="getStatusClasses(event?.status)">
                    {{ event?.status || 'En attente' }}
                  </span>
                </div>

                <!-- Motif d'annulation (si le RDV est annulé) -->
                <div v-if="(event?.statut === 'annulé' || event?.status === 'annulé') && event?.motif_annulation" class="flex flex-col gap-1 pt-2 border-t transition-colors duration-200"
                  :class="isDark ? 'border-zinc-900' : 'border-gray-200'">
                  <span class="transition-colors duration-200 text-[10px] uppercase tracking-wider font-medium" :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Motif d'annulation</span>
                  <span class="text-xs italic transition-colors duration-200" :class="isDark ? 'text-rose-400' : 'text-rose-600'">
                    "{{ event?.motif_annulation }}"
                  </span>
                </div>

                <!-- Réduction appliquée -->
                <div v-if="event?.reductionAppliquee && event?.reductionAppliquee > 0"
                     class="flex justify-between items-center pt-2 border-t transition-colors duration-200"
                     :class="isDark ? 'border-zinc-900/40' : 'border-gray-200'">
                  <span class="text-xs transition-colors duration-200" :class="isDark ? 'text-emerald-400' : 'text-emerald-600'">
                    {{ event?.detailsReduction || 'Réduction appliquée' }}
                  </span>
                  <span class="font-mono font-medium text-xs text-emerald-600 dark:text-emerald-400">
                    -{{ event.reductionAppliquee.toFixed(2) }}€
                  </span>
                </div>

                <div class="flex justify-between items-center pt-0.5">
                  <span class="transition-colors duration-200" :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Grand Total Comptable</span>
                  <span class="font-mono font-medium text-sm transition-colors duration-200" :class="isDark ? 'text-[#D5CCBC]' : 'text-blue-600'">{{ calculateTotal(event) }}</span>
                </div>
              </div>
            </div>

<div v-if="event?.paymentAmount !== undefined && event?.paymentAmount !== null" 
     class="pt-2 border-t mt-2 transition-colors duration-200"
     :class="isDark ? 'border-zinc-900/40' : 'border-gray-200'">
  
  <div class="flex justify-between items-center mb-1">
    <span class="text-[10px] uppercase font-medium" :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Statut Paiement</span>
    <span class="text-[10px] font-bold uppercase"
          :class="(event.isPaidCompletely || (calculateTotalAmount(event) - event.paymentAmount) <= 0) ? 'text-emerald-500' : 'text-amber-500'">
      {{ (event.isPaidCompletely || (calculateTotalAmount(event) - event.paymentAmount) <= 0) ? 'Payé intégralement' : 'Acompte versé' }}
    </span>
  </div>

  <div class="flex justify-between items-center">
    <span class="text-xs" :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Montant déjà perçu</span>
    <span class="font-mono text-xs font-medium" :class="isDark ? 'text-zinc-200' : 'text-gray-900'">
      {{ event.paymentAmount.toFixed(2) }}€
    </span>
  </div>

  <div v-if="(calculateTotalAmount(event) - event.paymentAmount) > 0" class="flex justify-between items-center">
    <span class="text-xs" :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Reste à payer</span>
    <span class="font-mono text-xs font-medium text-rose-500">
      {{ (calculateTotalAmount(event) - event.paymentAmount).toFixed(2) }}€
    </span>
  </div>
</div>
            <div v-if="event?.note" class="border p-4 rounded-xl space-y-2 transition-colors duration-200"
              :class="isDark ? 'border-zinc-900 bg-zinc-900/30 hover:border-zinc-800' : 'border-gray-200 bg-gray-50 hover:border-gray-300'">
              <h3 class="text-[10px] uppercase tracking-widest font-medium font-mono transition-colors duration-200"
                :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Consignes & Notes Directives</h3>
              <p class="text-[11px] leading-relaxed italic transition-colors duration-200"
                :class="isDark ? 'text-zinc-500' : 'text-gray-600'">"{{ event?.note }}"</p>
            </div>


            
          </div>

          <!-- Alerte pour événements Google -->
          <div v-if="isGoogleEvent" class="mx-5 mb-3 p-3 rounded-lg border transition-colors duration-200"
            :class="isDark ? 'bg-blue-950/20 border-blue-900/40 text-blue-400' : 'bg-blue-50 border-blue-200 text-blue-700'">
            <div class="flex items-start gap-2">
              <svg class="w-4 h-4 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p class="text-[11px] leading-relaxed">
                <strong>Événement Google Calendar</strong><br>
                Certaines actions sont limitées. Modifiez cet événement dans Google Calendar pour le mettre à jour.
              </p>
            </div>
          </div>

          <footer class="p-5 border-t flex flex-col gap-2 shrink-0 transition-colors duration-200"
            :class="isDark ? 'border-zinc-900/60 bg-zinc-950' : 'border-gray-200 bg-gray-50'">
            <div class="grid grid-cols-2 gap-2">
              <button
                @click="$emit('edit', event)"
                :disabled="isGoogleEvent"
                class="px-4 py-2.5 rounded-xl text-[11px] font-medium uppercase tracking-wider transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                :class="isDark
                  ? 'bg-zinc-900 hover:bg-zinc-800 text-zinc-200 border border-zinc-800 hover:border-zinc-700'
                  : 'bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-300 hover:border-gray-400'">
                Modifier
              </button>
              <button
                @click="$emit('cancel', event)"
                :disabled="isGoogleEvent"
                class="px-4 py-2.5 rounded-xl text-[11px] font-medium uppercase tracking-wider transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                :class="isDark
                  ? 'bg-red-950/20 hover:bg-red-950/50 text-red-400 border border-red-900/40'
                  : 'bg-red-50 hover:bg-red-100 text-red-600 border border-red-200'">
                Annuler l'acte
              </button>
            </div>

            <div class="grid grid-cols-2 gap-2">
              <button
                @click="$emit('payment', event)"
                :disabled="isGoogleEvent"
                class="px-4 py-2.5 rounded-xl text-[11px] font-semibold uppercase tracking-wider transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                :class="isDark
                  ? 'bg-emerald-950/20 hover:bg-emerald-950/40 text-emerald-400 border border-emerald-900/40 hover:border-emerald-800 shadow-lg shadow-emerald-900/5'
                  : 'bg-emerald-50 hover:bg-emerald-100 text-emerald-700 border border-emerald-200 hover:border-emerald-300'">
                <i class="fas fa-euro-sign mr-1.5"></i>
                Paiement
              </button>
              <button
                @click="$emit('remind', event)"
                class="px-4 py-2.5 rounded-xl text-[11px] font-semibold uppercase tracking-wider transition-colors shadow-lg focus:outline-none"
                :class="isDark
                  ? 'bg-white hover:bg-[#D5CCBC] text-black shadow-white/5'
                  : 'bg-blue-600 hover:bg-blue-700 text-white shadow-blue-600/20'">
                Rappel
              </button>
            </div>
          </footer>

        </div>
      </transition>

    </div>
  </transition>
</template>

<style scoped>
/* Technical override for fluid and seamless sidebar transitions */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* System scrollbar resets */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>

<script setup>
import { computed } from 'vue';
import { useTheme } from '@/composables/useTheme';

const { isDark } = useTheme();

const props = defineProps({
  visible: Boolean,
  event: Object
});

defineEmits(['close', 'edit', 'cancel', 'remind', 'payment']);

// Détecter si c'est un événement Google Calendar
const isGoogleEvent = computed(() => {
  return props.event?.isSyncedFromGoogle === true ||
         props.event?.metadata?.source === 'google_calendar' ||
         props.event?.metadata?.googleEventId;
});

console.log(props)

const calculateTotalAmount = (event) => {
  // Si montantAvantReduction existe et > 0, l'utiliser (montant réel à payer après réduction)
  if (event?.montantAvantReduction && event.montantAvantReduction > 0) {
    // Le montant à payer est le montant avant réduction - la réduction
    const reductionAppliquee = event?.reductionAppliquee || 0;
    return event.montantAvantReduction - reductionAppliquee;
  }

  // Sinon, calculer le total brut des services
  if (!event?.service) return 0;
  return event.service.reduce((sum, s) => sum + (s.prix || 0), 0);
};

function formatHourMinute(date) {
  if (!date) return '';
  const d = new Date(date);
  return `${d.getHours().toString().padStart(2,'0')}:${d.getMinutes().toString().padStart(2,'0')}`;
}

function formatDate(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
}

function calculateTotal(event) {
  if (!event || !event.service || !Array.isArray(event.service)) {
    return '0,00 €';
  }

  const total = event.service.reduce((sum, service) => {
    return sum + (service.prix || 0);
  }, 0);

  return `${total.toFixed(2).replace('.', ',')} €`;
}

// Classes de statut avec support du thème
function getStatusClasses(status) {
  const statusLower = (status || '').toLowerCase();

  if (statusLower === 'confirmé' || statusLower === 'validé') {
    return isDark.value
      ? 'bg-emerald-950/40 text-emerald-400 border-emerald-900/40'
      : 'bg-emerald-100 text-emerald-700 border-emerald-200';
  } else if (statusLower === 'en attente') {
    return isDark.value
      ? 'bg-amber-950/40 text-amber-400 border-amber-900/40'
      : 'bg-amber-100 text-amber-700 border-amber-200';
  } else if (statusLower === 'annulé') {
    return isDark.value
      ? 'bg-red-950/40 text-red-400 border-red-900/40'
      : 'bg-red-100 text-red-700 border-red-200';
  }

  return isDark.value
    ? 'bg-zinc-900 text-zinc-400 border-zinc-800'
    : 'bg-gray-100 text-gray-600 border-gray-200';
}
</script>

<style scoped>
.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s ease;
}
.slide-enter-from {
  transform: translateX(100%);
}
.slide-leave-to {
  transform: translateX(100%);
}
</style>
